export const FEATURE_NAMESPACE = 'feature.performance-reports'
